import _ from 'lodash'

export const LOCALE_PREFIX = 'components.Dialog.components.Confirm'

export const CONFIRM_DIALOG_ON_BUTTON_CLICK = (buttonType, id) =>
    `CONFIRM_DIALOG_ON_BUTTON_CLICK_${_.toUpper(buttonType)}${id ? `_${_.toUpper(id)}` : ''}`
